var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['confirm-btn', { hide: !_vm.showCo }]},[_c('div',{on:{"click":_vm.del}},[_vm._v("Eyða leit")]),_c('div',{staticClass:"color-primary",on:{"click":_vm.cancelConfirm}},[_vm._v("Hætta við")])])
}
var staticRenderFns = []

export { render, staticRenderFns }